import React, { useState, useEffect } from 'react';
import BasePage from '../../components/BasePage';
import PanelTicket from '../../components/Panels/PanelTicket';
import { format } from 'date-fns';

const ListeTickets = (props) => {

    const content = (data) => {
        console.log(data);
        const tickets = Array.isArray(data.tickets) ? data.tickets : [];

        return (
            <div id="liste-tickets" className='mt-4'>

                <div className="tickets">
                    {tickets.length === 0 ? (
                        <div className='bloc-info p-10 mb-8 mt-8 flex flex-col justify-center'>
                            <p className='text-lg font-bold uppercase bold text-center'>Pas de demande en cours pour le moment.</p> 
                        </div>
                    ) : (
                        tickets.map((ticket, index) => 
                            <PanelTicket key={index} data={ticket} />
                        )
                    )}
                </div>
            </div>
        )
    }

    return <BasePage url="/liste" content={content} title="Mes demandes" />;
}

export default ListeTickets;